import { __assign, __rest } from "tslib";
/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from './Icon';
import './SearchInput.scss';
var SearchInputSizes = {
    MEDIUM: 'medium',
    SMALL: 'small'
};
var SearchInput = function (_a) {
    var className = _a.className, onChange = _a.onChange, onClear = _a.onClear, onSubmit = _a.onSubmit, placeholder = _a.placeholder, shouldAutoFocus = _a.shouldAutoFocus, size = _a.size, value = _a.value, props = __rest(_a, ["className", "onChange", "onClear", "onSubmit", "placeholder", "shouldAutoFocus", "size", "value"]);
    var handleKeyDown = function (event) {
        if (event.key === 'Enter' && onSubmit) {
            onSubmit();
        }
    };
    var searchClassName = classnames('SearchInput', className, "SearchInput--".concat(size));
    var closeIconClassName = classnames('SearchInput__closeIcon', {
        'SearchInput__closeIcon--isVisible': value
    });
    return (React.createElement("div", __assign({}, props, { className: searchClassName }),
        React.createElement(Icon, { "data-testid": 'SearchInput__submit', onClick: onSubmit, size: 'medium', type: 'search' }),
        React.createElement("input", { autoFocus: shouldAutoFocus, className: 'SearchInput__input', "data-testid": 'SearchInput__input', onChange: function (event) { return onChange(event.target.value); }, onKeyDown: handleKeyDown, placeholder: placeholder, value: value !== null && value !== void 0 ? value : '' }),
        React.createElement(Icon, { className: closeIconClassName, "data-testid": 'SearchInput__clear', onClick: onClear, size: 'small', type: 'close' })));
};
SearchInput.defaultProps = {
    onSubmit: function () { },
    shouldAutoFocus: false,
    size: SearchInputSizes.MEDIUM,
    value: ''
};
SearchInput.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    placeholder: PropTypes.string,
    shouldAutoFocus: PropTypes.bool,
    size: PropTypes.oneOf(Object.values(SearchInputSizes)),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map